let mockFunctions = {
    UserHasCompletedAssessment: (email) => {
        return email === "completed@gmail.com";
    }
}

export default mockFunctions;